import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3rem 2rem;
  background: radial-gradient(circle at top left, #0b0617, #000);
  overflow-x: hidden;
`;

const Content = styled.div`
  max-width: 950px;
  text-align: center;
  color: #fff;
  padding: 3rem 2.5rem;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  box-shadow: 0 0 25px rgba(155, 92, 255, 0.15);
  animation: fadeIn 0.5s ease;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(15px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 768px) {
    padding: 2rem 1.5rem;
  }
`;

const Title = styled.h1`
  font-size: 2.8rem;
  margin-bottom: 1rem;
  font-weight: 700;
  background: linear-gradient(90deg, #a855f7, #c59fff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: 1px;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const Description = styled.p`
  font-size: 1.15rem;
  line-height: 1.8;
  margin-bottom: 2.5rem;
  color: #c7c7c7;
  max-width: 800px;
  margin-inline: auto;
  text-align: center;
`;

const CardsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1.8rem;
  margin-top: 2rem;
`;

const Card = styled.div`
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(155, 92, 255, 0.15);
  padding: 1.8rem 1.5rem;
  border-radius: 16px;
  transition: all 0.35s ease;
  backdrop-filter: blur(6px);
  cursor: default;
  box-shadow: 0 0 0 rgba(155, 92, 255, 0);

  &:hover {
    transform: translateY(-6px) scale(1.02);
    background: rgba(255, 255, 255, 0.12);
    box-shadow: 0 0 20px rgba(155, 92, 255, 0.25);
  }

  h3 {
    margin-bottom: 0.75rem;
    color: #fff;
    font-size: 1.25rem;
    font-weight: 600;
    background: linear-gradient(90deg, #9b5cff, #c59fff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  p {
    font-size: 0.98rem;
    color: #bdbdbd;
    line-height: 1.6;
  }
`;

const AboutPage = () => {
  return (
    <Wrapper>
      <Content>
        <Title>About SolveMyCodeIssue</Title>
        <Description>
          We’re building a global platform where developers solve real-world
          coding challenges, showcase projects, and get hired by top companies.
          Our goal is to make coding collaboration and career growth effortless
          and rewarding for every developer.
        </Description>

        <CardsWrapper>
          <Card>
            <h3>🚀 Our Mission</h3>
            <p>
              To empower developers worldwide by connecting them with learning,
              earning, and collaboration opportunities.
            </p>
          </Card>
          <Card>
            <h3>💡 What We Offer</h3>
            <p>
              Post and solve code issues, build live portfolios, and access
              freelance and referral job opportunities — all in one place.
            </p>
          </Card>
          <Card>
            <h3>🌍 Our Vision</h3>
            <p>
              To become the go-to hub for developers to learn, grow, and get
              recognized for their skills in the global tech community.
            </p>
          </Card>
        </CardsWrapper>
      </Content>
    </Wrapper>
  );
};

export default AboutPage;
